/* eslint-disable @typescript-eslint/no-unused-vars */
import { Box } from '@react-native-material/core';
import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Text } from 'react-native-paper';
import { useLocation } from 'react-router-dom';

import { dashboard } from '@assets/styles/pagesStyle';
import FamilySelector from '@shared/components/common/FamilySelector';
import WelcomeUserContainer from '@shared/components/common/LoggedInWelcome';
import PageContainer from '@shared/components/common/PageContainer';

import FamilyTable from '../components/FamilyTable';

export default function ManageFamily() {
  const location = useLocation();
  const { isFamilyMember } = location.state || {};

  return (
    <PageContainer isClient={true}>
      <Box
        id="content"
        style={(dashboard.centeredContainer, styles.boxMarginFlex)}>
        <View style={styles.welcomeHeader}>
          <Box>
            <WelcomeUserContainer />
            <Text variant="titleLarge">Family</Text>
          </Box>
          <Box>
            <FamilySelector />
          </Box>
        </View>
        <FamilyTable />
      </Box>
    </PageContainer>
  );
}

const styles = StyleSheet.create({
  boxMarginFlex: {
    flex: 1,
    margin: 10,
  },
  welcomeHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: 10,
    width: '100%',
    zIndex: 20,
  },
});
